// Phase 4 texts for taxi/VTC fleets (docs/flotas-drivers): fleet types,
// dispatch centre (ranks, zones and dispatch), passenger fee and challenges.
// Registered in AppComponent and merged with drivers-fleet/en.ts.
export const locale = {
  lang: 'en',
  data: {
    DRIVERS_FLEET: {
      KIND: {
        dispatch_center: 'Taxi dispatch centre',
        owner_operator: 'Taxi owner-operator',
        vtc_fleet: 'VTC fleet',
      },
      EMPLOYMENT_TYPE: {
        associate: 'Member',
      },
      DEMAND_CHANNEL: {
        waiis_app: 'WAIIS app',
        emitter_phone: 'Dispatch centre phone',
        emitter_web: 'Dispatch centre website',
        stand: 'Taxi rank',
        street_hail: 'Street hail',
      },
      SERVICE_TYPE: {
        immediate: 'Immediate',
        reservation: 'Booking',
        airport_premium: 'Premium or airport',
      },
      DISPATCH_STRATEGY: {
        proximity: 'Closest',
        stand_order: 'Taxi rank order',
        zone: 'By zone',
      },
      CHALLENGE_STATUS: {
        draft: 'Draft',
        scheduled: 'Scheduled',
        active: 'Running',
        finished: 'Finished',
        cancelled: 'Cancelled',
      },
      SIGNUP: {
        KIND_TITLE_dispatch_center: 'Taxi dispatch centre',
        KIND_TITLE_owner_operator: 'Taxi licence owner',
        KIND_TITLE_vtc_fleet: 'Offer trips with VTC licences',
        KIND_HINT_dispatch_center: 'Association or radio taxi: your members have their own licence and car. Taxi ranks, zones and dispatch.',
        KIND_HINT_owner_operator: 'One or more municipal licences, with drivers working them in shifts.',
        KIND_HINT_vtc_fleet: 'Company or operator with VTC licences, with salaried or self-employed drivers.',
      },
      GEO: {
        TOOLS_ARIA: 'Map tools',
        DRAW: 'Draw',
        PLACE_POINT: 'Place the point',
        UNDO: 'Undo',
        CLEAR: 'Clear',
        RECENTER: 'Fit to view',
        ZOOM_IN: 'Zoom in',
        ZOOM_OUT: 'Zoom out',
        HINT_START: 'Click on the map to add points ({{count}} of 3 minimum).',
        HINT_EDIT: 'Drag a point to move it; double-click to remove it. Click on the map to add more.',
        HINT_POINT: 'Click on the map or drag the marker to place the taxi rank point.',
        HINT_INVALID: 'The zone’s sides cross: move or remove a point.',
        POLYGON_REQUIRED: 'Draw the zone with at least 3 points and no crossing sides.',
      },
      OPS: {
        SAVE: 'Save',
        SHIFTS: {
          SUB: 'They repeat every week. Tap a cell to change who drives that car that day.',
          CHANGE_HOURS: 'Change hours',
          NO_DRIVER: 'No driver',
          FIXED: 'Fixed shift',
          REPEAT: 'Repeat',
          DAY_LETTER: { 1: 'M', 2: 'T', 3: 'W', 4: 'T', 5: 'F', 6: 'S', 7: 'S' },
          CLASH: '{{name}} already has the {{slot}} shift in another car on one of those days.',
          PICK_DAY: 'Pick at least one day.',
          CONFLICT: 'A driver is in two cars at the same time. Check the shifts.',
          SAVED_TITLE: 'Shift saved',
          SAVED_FROM: 'It applies from {{date}}.',
        },
        VEHICLES: {
          KPIS_ARIA: 'Vehicles summary',
          KPI_ON_STREET: 'On the road now',
          KPI_ALERTS: 'MOT or insurance within 45 days',
          TAB_ON_STREET: 'On the road',
          TAB_PARKED: 'Parked',
          TAB_WITHOUT_DRIVER: 'No driver',
          TAB_WITH_ALERTS: 'With alerts',
          SEARCH: 'Search plate or model',
          COL_VEHICLE: 'Vehicle',
          COL_KM: 'Km',
          PRESENCE_on_street: 'On the road',
          PRESENCE_parked: 'Parked',
          NEXT_UPLOAD: 'Documents still to upload',
          NEXT_SUBMIT: 'Ready to send for review',
          NEXT_FIX: 'Upload the rejected document again',
          NEXT_WAIT: 'We review it in under 24 h',
          N_SHIFTS: '{{count}} shifts',
          ASSIGN: 'Assign driver',
          COMPLETE: 'Complete',
          EMPTY: 'No vehicles yet. Plate, licence and 4 documents: we review them within 24 h.',
          ADD_SUB: 'We review it in under 24 h.',
          REJECTED_NOTE: 'A document was rejected. Upload it again and the car goes back to review.',
          MUNICIPALITY: 'Licence municipality',
          MORE_DATA: 'Make, model, year, seats and km',
          YEAR: 'Year',
          KM_HINT: 'The driver app updates it; you can correct it here.',
          DATA_INVALID: 'Check the year (1990 onwards) and the seats (1 to 8).',
          NO_DRIVERS: 'Nobody drives this car yet.',
          EDIT_SHIFTS: 'Edit shifts',
          DOCS_COUNT: 'Documents {{done}}/{{total}}',
          DOC_PENDING: 'Pending',
          DOC_UPLOADED: 'Uploaded',
          DOC_IN_REVIEW: 'Under review',
          DOC_REJECTED: 'Rejected: {{reason}}',
          DOC_UNTIL: 'Valid until {{date}}',
          DOC_VALID: 'Valid',
          CHECKS: {
            circulation_permit: 'Both sides|All 4 corners visible|Plate readable',
            technical_sheet_itv: 'Both sides|Next MOT date visible|No crossings-out or glare',
            insurance_policy: 'All pages|Expiry and plate readable|Third-party liability included',
            taxi_municipal_license: 'Number and municipality visible|In force|One per vehicle',
            vtc_transport_card: 'Same vehicle as the registration certificate|Authorisation number readable|One per vehicle',
          },
          DOCS_AFTER: 'Save the details, then upload the 4 documents.',
          SUBMIT_HINT: 'With the 4 documents uploaded, send it for review. Until then it stays incomplete.',
          SAVE_AND_DOCS: 'Save and upload documents',
          SAVE_LATER: 'Save and continue later',
          SUBMIT: 'Send for review',
          SUBMIT_DISABLED: 'Upload the 4 documents to send it.',
          SUBMITTED_TITLE: '{{plate}} sent for review',
          SUBMITTED_TEXT: 'We review it in under 24 h. We’ll let you know when it can work.',
          MISSING_DOCS: 'Some documents are still missing.',
        },
        OVERVIEW: {
          NOW_TITLE: 'Now',
          NOW_SUB: '{{count}} drivers online. Updates every 30 seconds.',
          NOW_LIVE: 'Live',
          NOW_STALE: 'Offline: data from a while ago',
          SEE_DRIVERS: 'See drivers',
          ATTENTION_EMPTY: 'All good: nothing pending.',
          ATTENTION_document_expired: 'Expired document',
          ATTENTION_document_rejected: 'Rejected document',
          ATTENTION_driver_without_vehicle: 'Driver without a car',
          ATTENTION_driver_request: 'Request to join',
          ATTENTION_GO_document_expired: 'Renew',
          ATTENTION_GO_document_rejected: 'Upload again',
          ATTENTION_GO_driver_without_vehicle: 'Assign',
          ATTENTION_GO_driver_request: 'Review',
          ATTENTION_MORE: 'And {{count}} more.',
          EXPIRED_ON: 'expired on {{date}}',
          REQUESTED_ON: 'requested on {{date}}',
          WEEK_TITLE: 'This week',
          WEEK_SUB: '{{from}} to {{to}} · {{trips}} trips',
          WEEK_GO: 'See settlement',
          WEEK_FARE: 'Revenue',
          WEEK_SHARE: 'Drivers’ share',
          WEEK_NET: 'Fleet net',
          WEEK_PAYOUT: 'Settled on {{date}}',
          AVERAGE: 'Average',
          CHART_INSIGHT: '{{total}} trips, {{average}} a day on average. The best day was {{day}}, with {{trips}}.',
          TOP_TITLE: 'Drivers with the most trips',
          TOP_Q: 'The 4 who worked the most in the last {{days}} days.',
          TOP_HOURS: '{{hours}} h online',
          START_VEHICLE: 'Add a vehicle',
          START_VEHICLE_HINT: 'Its plate, licence and the car documents.',
          START_CODE: 'Share the code with your drivers',
          START_CODE_HINT: 'They enter it in the WAIIS Driver app and you get their request.',
          START_SHIFTS: 'Assign shifts',
          START_SHIFTS_HINT: 'Who drives each car in the morning, afternoon and night.',
          START_SHIFTS_LOCKED: 'You need a car and an accepted driver first.',
          FLEET_TITLE: 'Your fleet',
          FLEET_SUB: 'How everything stands while WAIIS reviews your application.',
          TO_ACCEPT: 'To accept',
          SETTLEMENTS_ON_APPROVAL: 'They start once WAIIS approves the fleet.',
        },
        DOCUMENTS: {
          KPIS_ARIA: 'Documents summary',
          KPI_STOPPED: 'Expired or rejected',
          KPI_EXPIRING: 'Expire within 45 days',
          VEHICLES_SUB: 'Most urgent first. Click a document to view it or upload a new one.',
          FISCAL: 'Tax details',
          VERIFIED: 'Verified',
          VALID: 'Valid',
          APPROVED_ON: 'Approved on {{date}}',
          CELL_BAD: 'Expired',
          CELL_REJ: 'Rejected',
          CELL_WARN: 'Expires soon',
          CELL_REV: 'In review',
          CELL_NONE: 'Missing',
          CELL_OK: 'Up to date',
          UPLOAD_SHORT: 'Upload',
          UPCOMING_TITLE: 'Upcoming expirations',
          UPCOMING_SUB: 'Next 4 months',
          UPCOMING_EMPTY: 'Nothing expires in the next 4 months.',
          EXPIRED_ON: 'Expired on {{date}}',
          EXPIRES_ON: 'Expires on {{date}}',
          CAR_STOPPED: ', car off the road',
          TODAY: 'today',
          DAYS_AGO: '{{count}} days ago',
          DAYS_AGO_ONE: '1 day ago',
          IN_DAYS: 'in {{count}} days',
          IN_DAYS_ONE: 'in 1 day',
          REVIEW_SUB: 'We review them in under 24 h.',
          REVIEW_EMPTY: 'Nothing sent yet.',
          DRIVER_DOCS_NOTE: 'Drivers upload their own documents from the app. You can see them on their profile.',
          NOTE_BAD: 'Expired. The car cannot go out until you upload the new one.',
          NOTE_REJ: 'Rejected. Check the reason and upload it again.',
          NOTE_WARN: 'Expires soon. Upload the renewed one and we will review it within 24 h.',
          NOTE_REV: 'In review. It usually takes us under 24 h.',
          NOTE_NONE: 'This document is missing.',
          NOTE_OK: 'Up to date.',
          NOTE_FISCAL_OK: 'Verified by WAIIS.',
          LEGAL_NAME: 'Legal name',
          TAX_ID: 'Tax ID',
          ADDRESS: 'Tax address',
          FISCAL_EMPTY: 'You have not filled in the tax details yet.',
          FISCAL_HINT: 'They are changed in Settings; if they change, WAIIS reviews them again.',
          GO_SETTINGS: 'Go to Settings',
          CURRENT_FILE: 'Current file',
          UPLOAD_FIRST: 'Upload the document',
          UPLOAD_NEW: 'Upload a new one',
          SAMPLE: 'What we check',
          CHECKS: {
            bank_ownership_certificate: 'IBAN and holder visible|In the company’s name|All 4 corners visible',
            route_sheet_authorization: 'Your tax ID and WAIIS’s are visible|Type Intermediary / Platform',
          },
        },
        SETTLEMENTS: {
          INFO_TEXT: 'Paying drivers from the wallet will come later. Here you see the statement, what each driver is owed and the movements.',
          STATEMENT: 'Statement',
          STATEMENT_EXPORT: 'Statement',
          STATEMENT_ERROR: 'The statement could not be loaded.',
          PREVIOUS: 'Previous period',
          NEXT: 'Next period',
          PERIOD_ARIA: 'Period',
          PERIOD_WEEK: 'Week',
          PERIOD_MONTH: 'Month',
          OPENING: 'Opening balance',
          TRIPS: 'Trips',
          TRIPS_COUNT: '{{count}} trips',
          TOLLS: 'Tolls',
          TOLLS_SUB: 'Refunded by the passenger',
          DRIVER_SHARE: 'Driver share',
          CANCELLATIONS: 'Charged cancellations',
          PAYOUTS: 'Paid out to your account',
          CLOSING: 'Closing balance',
          AVAILABLE_ON: 'Available on {{date}}',
          FEE_INFO: 'Passenger fee: {{amount}}. Passengers pay it on top of the fare; it is not taken from your balance.',
          BY_DRIVER: 'Share by driver',
          BY_DRIVER_SUB: '{{amount}} in total. Salaried drivers are not listed: they have no share.',
          BY_DRIVER_EMPTY: 'Nobody has a share in this period.',
          COL_GENERATED: 'Generated',
          COL_SHARE: 'Share',
          COL_PAYABLE: 'To pay',
          COL_STATUS: 'Status',
          STATUS_PAID: 'Paid',
          STATUS_PENDING: 'Pending',
          PAID_AT: 'Paid on {{date}}',
          WALLET: 'Fleet wallet',
          HELD: 'Held',
          HELD_UNTIL: 'Held until {{date}}',
          SHARE_SUB: 'What the driver keeps. You can change it on each driver’s profile.',
          SHARE_HINT: 'Salaried drivers have no share. It does not change drivers already accepted.',
          SAVED: 'Saved',
          WAITING_TITLE: 'They start once the fleet is approved',
          WAITING_TEXT: 'Every Monday you will see the week’s balance and the share by driver.',
          WAITING_IBAN: 'You get paid into {{iban}}.',
        },
        PERFORMANCE: {
          NO_DATA_TITLE: 'No data yet',
          NO_DATA_TEXT: 'It will show up once your drivers start doing trips.',
          KPIS_ARIA: 'Performance over the last 4 weeks',
          KPI_RATING: 'Average rating',
          KPI_ACCEPTANCE: 'Acceptance',
          KPI_CANCELLATION: 'Driver cancellation',
          KPI_FARE_HOUR: '€ per online hour',
          DRIVERS_SUB: 'Last 4 weeks.',
          SORT_ARIA: 'Sort by',
          SORT_FARE_PER_HOUR: '€ / hour',
          SORT_RATING: 'Rating',
          SORT_ACCEPTANCE_RATE: 'Acceptance',
          SORT_TRIPS: 'Trips',
          COL_FARE_HOUR: '€ / h',
          COL_CANCELLATION: 'Cancel.',
          DEMAND_TITLE: 'Busiest hours',
          DEMAND_SUB: 'Trips per hour, average of {{weeks}} weeks.',
          DEMAND_TIP: '{{hour}} h: {{trips}} trips',
          PEAK: 'From {{from}} to {{to}} h is when demand peaks: {{trips}} trips per hour.',
          PEAK_PARKED: 'From {{from}} to {{to}} h you have {{parked}} cars parked and {{trips}} trips per hour. That is where an extra shift helps most.',
        },
        REPORTS: {
          MONTHS_ARIA: 'Month',
          CLOSED_ON: 'Closed on {{date}}',
          OPEN: 'Current month',
          PAID_DRIVERS: 'Paid to drivers',
          DRIVERS_COUNT: '{{count}} drivers',
          NET: 'Fleet net',
          FEE: 'Passenger fee',
          FEE_SUB: 'For information only',
          DOWNLOAD_TITLE: 'Download',
          DOWNLOAD_SUB: 'For the selected month.',
          REPORT_trips: 'Trips',
          REPORT_trips_HINT: 'Driver, vehicle, amount, channel and fee of each trip',
          REPORT_driver_settlements: 'Settlement by driver',
          REPORT_driver_settlements_HINT: 'One PDF per driver, ready for the accountant',
          REPORT_route_sheets: 'Route sheets',
          REPORT_route_sheets_HINT: 'What was reported to the Ministry, by vehicle',
          COUNT_ROWS: '{{count}} rows',
          COUNT_FILES: '{{count}} files',
          COUNT_VEHICLES: '{{count}} vehicles',
          FILE_trips: 'trips',
          FILE_driver_settlements: 'driver_settlements',
          FILE_route_sheets: 'route_sheets',
          PAST_TITLE: 'Previous months',
          COL_MONTH: 'Month',
          ACCOUNTANT_TITLE: 'Accountant',
          MONTHLY_EMAIL: 'Send the settlement every month',
          MONTHLY_EMAIL_SUB: 'On the 1st, for the closed month.',
          EMAIL: 'Accountant’s email',
          EMAIL_PLACEHOLDER: 'accountant@example.com',
          EMAIL_INVALID: 'Enter a valid email.',
          EMAIL_REQUIRED: 'Enter the accountant’s email to turn sending on.',
          ACCOUNTANT_ACCESS: 'Direct access to the panel',
          ACCOUNTANT_ACCESS_SUB: 'Invite them in Team with the Accountant role.',
        },
        TEAM: {
          INVITE: 'Invite',
          INVITE_TITLE: 'Invite to the team',
          ROLES_TITLE: 'Roles',
          YOUR_ROLE: 'Your role',
          ROLE_SUB_fleet_owner: 'Everything, including money and the team',
          ROLE_SUB_fleet_manager: 'Day-to-day operations',
          ROLE_SUB_fleet_accountant: 'Only money and paperwork',
          AREA_DRIVERS_VEHICLES: 'Drivers and vehicles',
          AREA_DOCUMENTS: 'Documents',
          AREA_MONEY: 'Settlements and wallet',
          AREA_REPORTS: 'Reports',
          AREA_TEAM_SETTINGS: 'Team and settings',
          COL_LAST_SEEN: 'Last access',
          INVITED_ON: 'Invited on {{date}}',
          RESEND: 'Resend',
          RESENT: 'Resent',
          RESEND_ERROR: 'The invitation could not be resent',
          ROLE_ERROR: 'The role could not be changed',
          ALREADY_MEMBER: '{{email}} is already on the team.',
          NAME: 'Name',
          NAME_PLACEHOLDER: 'First and last name',
          EMAIL_PLACEHOLDER: 'name@company.com',
        },
        SETTINGS: {
          BANK_TITLE: 'Bank account',
          BANK_SUB: 'Where you receive your settlements.',
          CHANGE_IBAN: 'Change the IBAN',
          IBAN_HINT: 'If you change the IBAN we will ask for a new account ownership certificate, and we review it before using it.',
          NEW_IBAN: 'New IBAN',
          IBAN_INVALID: 'Enter a Spanish IBAN: ES and 22 digits.',
          IBAN_CERT_HINT: 'From the bank, in the company’s name, with the new IBAN visible.',
          SAVE_IBAN: 'Save IBAN and certificate',
          RULES_TITLE: 'Rules',
          RULES_SUB: 'They apply to every driver in the fleet.',
          RULE_expiryReminders: 'Warn before a document expires',
          RULE_expiryReminders_HINT: '30 and 7 days before, to the driver and to you',
          RULE_blockOnExpiry: 'Block on expiry',
          RULE_blockOnExpiry_HINT: 'The driver cannot go online until they renew. The car is freed.',
          RULE_acceptCash: 'Accept cash',
          RULE_acceptCash_HINT: 'The driver declares it in the app and it is deducted from their settlement',
          RULE_cancellationAlert: 'Cancellation alert',
          RULE_cancellationAlert_HINT: 'If a driver goes over 5 % in the week',
        },
        ONBOARDING: {
          ENTITY_NOTE: 'Choose Company if you invoice through a company (SL, SA, cooperative…), even if you are the only partner. Choose Self-employed if you invoice in your own name. The details we ask for depend on it.',
          TAX_ID_HINT: 'The one the Tax Agency gave you. We use it on your invoices.',
          VTC_TAX_ID_NOTE: 'It must be the same tax ID under which your VTC licences are in the Ministry Register. If it does not match, we cannot report your route sheets.',
          VTC_ROUTE_SHEETS_NOTE: 'WAIIS reports each service to the Ministry Register for you. You only need to authorise us (we ask for it in the authorisation step). Not issuing them can lead to a fine.',
          REP_TITLE: 'Representative and fleet',
          SIZE_TITLE: 'Fleet size',
          SIZE_VALUE: '{{vehicles}} vehicles · {{drivers}} drivers',
          SIZE_VEHICLES: 'Vehicles',
          SIZE_DRIVERS: 'Drivers',
          REP_ROLE_LABEL: 'Your role in the company',
          REP_PLACEHOLDER: 'Choose your role',
          REP_REQUIRED: 'Choose your role in the company.',
          REP_ROLE: {
            sole_admin: 'Sole director',
            joint_admin: 'Joint or several director',
            shareholder_25: 'Shareholder with over 25 %',
            attorney: 'Attorney',
          },
          OWNERS_LABEL: 'Shareholders with over 25 %',
          OWNER_NAME: 'First and last name',
          OWNER_ID: 'DNI / NIE',
          OWNER_ADD: 'Add another shareholder',
          OWNER_REMOVE: 'Remove shareholder',
          OWNERS_INVALID: 'Enter the name and a valid DNI or NIE for each shareholder.',
          DISCLAIMER_TITLE: 'I accept the disclaimer',
          DISCLAIMER_REQUIRED: 'Accept the disclaimer to save.',
          CAPTURE_LIKE_THIS: 'Capture it like this',
          OPEN_REGISTRY: 'Open the VTC Register',
          NEW_TAB: '(opens in a new tab)',
          ROUTE_STEP_1: 'Sign in to the Ministry VTC Register with Cl@ve or your digital certificate.',
          ROUTE_STEP_2: 'Under “Authorise communications”, authorise WAIIS’s tax ID:',
          ROUTE_STEP_3: 'As the type, choose “Intermediary / Platform” and tick “Manage all my licences”.',
          ROUTE_STEP_4: 'Take a screenshot showing your tax ID and the authorised one, and upload it here.',
          COPY: 'Copy',
          COPIED: 'Copied',
          SEND_TITLE: 'Send for review',
          SEND_SUB: 'We review it in under 24 h and let you know by email.',
          MEANWHILE: 'In the meantime',
          ON_APPROVAL: 'Once approved',
          MEANWHILE_VEHICLES: 'Add vehicles and their documents',
          MEANWHILE_CODE: 'Share your code with drivers',
          MEANWHILE_SHIFTS: 'Set up shifts',
          APPROVAL_DRIVERS: 'Drivers can go online',
          APPROVAL_SETTLEMENTS: 'Settlements start',
        },
        DRIVERS: {
          TAB_AVAILABLE: 'Available',
          TAB_ON_TRIP: 'On a trip',
          TAB_OFFLINE: 'Offline',
          TAB_PENDING: 'Requests',
          ADD: 'Add driver',
          ADD_SUB: 'They join with your fleet code from the WAIIS Driver app.',
          ADD_NOTE: 'Once they enter it, their request will show up here. Accepting it is all you need to do.',
          COPY: 'Copy',
          COPIED: 'Copied',
          COPY_MESSAGE: 'Copy message',
          CHANGE_CODE: 'Change code',
          DONE: 'Done',
          STEPS_TITLE: 'How they join',
          STEP_1: 'They download the WAIIS Driver app and create their account.',
          STEP_2: 'They upload their ID, driving licence and professional driver permit.',
          STEP_3: 'In “Join a fleet” they enter the code {{code}}.',
          STEP_4: 'You accept their request on this screen and they can start working for your fleet.',
          MESSAGE_TITLE: 'Message to send them',
          JOIN_MESSAGE: 'Hi! To work with us, download the WAIIS Driver app, create your account and, in “Join a fleet”, enter the code {{code}}. As soon as we accept you, you can start.',
          KPIS_ARIA: 'Drivers summary',
          KPI_ONLINE: 'Online now',
          SEARCH: 'Search by name, phone or plate',
          COL_STATE: 'Status',
          COL_NEXT: 'Next step',
          COL_VEHICLE: 'Vehicle',
          COL_SHIFT: 'Shift',
          COL_TRIPS: 'Trips',
          COL_RATING: 'Rating',
          COL_WEEK: '€ this week',
          EMPTY_all: 'You have no drivers yet. Send them the fleet code so they can join.',
          EMPTY_available: 'Nobody is available right now.',
          EMPTY_on_trip: 'Nobody is on a trip right now.',
          EMPTY_offline: 'All your drivers are online.',
          EMPTY_pending: 'No pending requests.',
          EMPTY_with_alerts: 'No driver has documents to renew.',
          YOU: 'You',
          STATE_PENDING: 'Request',
          STATE_REJECTED: 'Rejected',
          STATE_INACTIVE: 'Deactivated',
          STATE_READY: 'Ready',
          STATE_VERIFYING: 'Verifying',
          STATE_ON_TRIP: 'On a trip',
          STATE_AVAILABLE: 'Available',
          STATE_OFFLINE: 'Offline',
          NEXT_ACCEPT: 'Accept their request',
          NEXT_APPROVAL: 'Waiting for WAIIS to approve the fleet',
          NEXT_VERIFY: 'WAIIS is checking their documents',
          DOCS_ok: 'Up to date',
          DOCS_warn: 'Expiring soon',
          DOCS_bad: 'Expired or rejected',
          DOCS_review: 'In review',
          DOCS_missing: 'Missing',
          PENDING_NOTE: 'Asked to join the fleet on {{date}}. Check their details and accept or reject the request.',
          STAT_HOURS: 'Online',
          VEHICLE_TITLE: 'Vehicle',
          VEHICLE_SHIFT_TITLE: 'Vehicle and shift',
          NO_VEHICLE: 'No vehicle assigned',
          NO_SHIFT: 'No shift',
          EDIT_SHIFTS: 'Edit shifts',
          SHARE_TITLE: 'Revenue split',
          SHARE_PERCENT: 'Percentage',
          SHARE_SPLIT: 'Driver {{driver}} % · Fleet {{fleet}} %',
          SALARIED_NOTE: 'Paid a salary: the fleet keeps what they bill.',
          SHARE_RANGE: 'The percentage must be between 30 and 80.',
          UNLINK: 'Unlink',
          DEACTIVATE: 'Deactivate',
          REACTIVATE: 'Reactivate',
          DEACTIVATE_TITLE: 'Deactivate {{name}}?',
          REACTIVATE_TITLE: 'Reactivate {{name}}?',
          DEACTIVATE_TEXT: 'They won’t be able to go online or get fleet trips until you reactivate them. They stay linked and keep their shifts.',
          REACTIVATE_TEXT: 'They will be able to go online and get fleet trips again.',
        },
        REVIEW_BAR: {
          IN_REVIEW_TITLE: 'Fleet under review',
          IN_REVIEW_TEXT: 'Add vehicles and share your code with your drivers. They’ll be able to go online once we approve the fleet.',
          REJECTED_TITLE: 'Something was rejected',
          REJECTED_REST: 'Everything else is still under review.',
          STEPS_ARIA: 'Sign-up steps',
          STEP_billing_info: 'Billing',
          STEP_bank_ownership_certificate: 'Bank',
          STEP_route_sheet_authorization: 'Route sheets',
          SEE_STATUS: 'See status',
          FIX: 'Upload again',
          START_WHILE_REVIEW: 'You can do this now: your drivers will be able to go online as soon as we approve the fleet.',
        },
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        REFRESH: 'Refresh',
        SHOW_MORE: 'Show more',
        COL_UPDATED: 'Updated',
        DELETING: 'Deleting…',
        DELETED: 'Deleted',
        REASON_PLACEHOLDER: 'Reason (required, kept in the audit log)',
        REASON_REQUIRED: 'Enter the reason.',
        ASSOCIATE_NOTE: 'Joins as a member of the dispatch centre: works with their own licence and car and keeps their full fares.',
        ACCEPT_ASSOCIATE_TITLE: 'Accept as member',
        SHARE_ASSOCIATE: 'Not applicable (member: keeps full fare)',
        STANDS: {
          ADD: 'New taxi rank',
          LIST_TITLE: 'Taxi ranks',
          LIST_SUB: 'Entering the geofence puts the driver in that taxi rank’s queue.',
          COL_NAME: 'Name',
          COL_QUEUE: 'In queue',
          COL_CAPACITY: 'Capacity',
          EMPTY: 'No taxi ranks yet.',
          LOAD_ERROR: 'Couldn’t load the taxi ranks.',
          QUEUE_TITLE: '{{name}} queue',
          QUEUE_SUB: 'Live: updates itself every 15 seconds.',
          QUEUE_EMPTY: 'Nobody is in the queue.',
          QUEUE_ERROR: 'Couldn’t load the queue.',
          QUEUE_RULES: 'Queue rules: after the consecutive rejections set by the dispatch policy, the driver leaves with a notice; skipping an offer because of requirements doesn’t lose their place. Rejecting never results in a fine.',
          WAITING: 'waiting {{minutes}} min',
          REJECTIONS: 'Consecutive rejections: {{count}}',
          REJECTIONS_TIP: 'Offers rejected in a row since joining the queue.',
          SKIPS: 'Skips due to requirements: {{count}}',
          SKIPS_TIP: 'Offers they couldn’t take (wheelchair access, pet…): they don’t count as a rejection.',
          REMOVE: 'Remove from queue',
          REMOVING: 'Removing…',
          REMOVED: 'Out of the queue',
          REMOVE_TITLE: 'Remove {{name}} from the queue',
          REMOVE_TEXT: 'They’ll leave the {{stand}} queue and get a notice.',
          REMOVE_PLACEHOLDER: 'Reason (required, the driver will see it)',
          REMOVE_ERROR: 'Couldn’t remove from the queue',
          DRAWER_SUB: 'Draw the geofence and place the taxi rank point.',
          DATA_TITLE: 'Taxi rank details',
          ADDRESS: 'Address',
          CAPACITY_HINT: 'Approximate: nobody is removed from the queue.',
          CAPACITY_INVALID: 'Between 1 and 50.',
          ACTIVE_LABEL: 'Active taxi rank',
          GEOFENCE_TITLE: 'Geofence and point',
          GEOFENCE_HINT: 'The area where the driver joins the queue. The point is what shows on the map and in the app.',
          POINT_INVALID: 'The taxi rank point must be inside its geofence.',
          CREATE: 'Create taxi rank',
          DELETE: 'Delete taxi rank',
          DELETE_TITLE: 'Delete the taxi rank {{name}}',
          DELETE_TEXT: 'Its queue is emptied and the drivers in it get a notice.',
          DELETE_ERROR: 'Couldn’t delete the taxi rank',
          DELETED_QUEUE: 'Taxi rank deleted. {{count}} drivers left the queue.',
        },
        ZONES: {
          ADD: 'New zone',
          TITLE: 'Zones',
          SUB: 'Used by the “By zone” dispatch and by reports. They can overlap: the smallest wins.',
          COL_NAME: 'Name',
          COL_POINTS: 'Points',
          EMPTY: 'No zones yet.',
          LOAD_ERROR: 'Couldn’t load the zones.',
          DRAWER_SUB: 'Draw the zone on the map. The others are shown in the background.',
          ACTIVE_LABEL: 'Active zone',
          SHAPE_TITLE: 'Zone shape',
          CREATE: 'Create zone',
          DELETE: 'Delete zone',
          DELETE_TITLE: 'Delete the zone {{name}}',
          DELETE_TEXT: 'It’s no longer used in dispatch. Past trips don’t change.',
          DELETE_ERROR: 'Couldn’t delete the zone',
        },
        POLICY: {
          LOAD_ERROR: 'Couldn’t load the dispatch policy.',
          NOTE_TITLE: 'Rejecting never results in a fine',
          NOTE_TEXT: 'These values only set who each service is offered to. Every change is saved in the history with its author.',
          STRATEGY_TITLE: 'How services are dispatched',
          STRATEGY_SUB: 'Who each service is offered to first among the available members.',
          STRATEGY_HINT_proximity: 'To the free member closest to the pickup.',
          STRATEGY_HINT_stand_order: 'To the first in the queue at the closest taxi rank; if there’s no queue, to the closest member.',
          STRATEGY_HINT_zone: 'First to the members in the pickup zone, in order of arrival in the zone.',
          INTRA_FLEET: 'Dispatch centre members get offers before other WAIIS drivers',
          QUEUE_TITLE: 'Offers and queue',
          QUEUE_SUB: 'How long each offer lasts and when someone leaves a taxi rank queue.',
          TIMEOUT_HINT: 'Time to accept an offer before moving on to the next one (10–60 s).',
          TIMEOUT_INVALID: 'Between 10 and 60 seconds.',
          REJECTIONS_HINT: 'Consecutive rejections after which the driver leaves the queue with a notice (1–5).',
          REJECTIONS_INVALID: 'Between 1 and 5.',
          LAST_CHANGE: 'Last change: {{name}}, {{date}}.',
          OUTDATED_TITLE: 'The policy has changed',
          HISTORY_TITLE: 'Change history',
          HISTORY_SUB: 'Who changed what and when.',
          HISTORY_EMPTY: 'No changes yet.',
          FIELD: {
            strategy: 'Dispatch',
            intra_fleet_priority: 'Member priority',
            offer_timeout_seconds: 'Time per offer',
            stand_max_consecutive_rejections: 'Consecutive rejections to leave the queue',
            skip_by_requirements_keeps_position: 'Skipping an offer because of requirements keeps the place in the queue',
          },
        },
        FEES: {
          ADD_RULE: 'New rule',
          ADD_RULE_SUB: 'A fee for a specific city, mode or service type.',
          EDIT_RULE: 'Change the fee',
          NOTE_TITLE: 'Only demand generated by WAIIS pays a fee',
          NOTE_TEXT:
            'It’s added to the trip price: the driver or fleet keeps the full fare. The dispatch centre’s own customers (their phone, their website, the taxi rank and the street) always pay €0. The fee is frozen when the trip is created.',
          LOAD_ERROR: 'Couldn’t load the passenger fee.',
          MATRIX_TITLE: 'Amounts',
          MATRIX_SUB: 'General rules apply to all cities; the others refine them.',
          COL_SERVICE: 'Service type',
          COL_AMOUNT: 'Fee',
          COL_CHANNEL: 'Channel',
          COL_STATE: 'Fee',
          COL_REASON: 'Reason',
          GENERAL: 'General',
          PRIORITY: 'For a trip, the most specific rule wins: city and mode, then city, then mode and finally the general one.',
          AMOUNT_HINT: 'From €0 to €10. With €0 no fee is charged.',
          AMOUNT_INVALID: 'Enter an amount between €0 and €10.',
          DUPLICATE: 'There’s already a rule for that city, mode and service type: change its amount.',
          REQUIRED_RULE: 'General rules can’t be deleted: set them to €0.',
          SAVE_ERROR: 'Couldn’t save the fee',
          DELETE: 'Delete rule',
          DELETE_TITLE: 'Delete the rule',
          DELETE_TEXT: '{{rule}}. From now on the most general remaining rule applies.',
          DELETE_ERROR: 'Couldn’t delete the rule',
          REGIONS_TITLE: 'Switch by city',
          REGIONS_SUB: 'With the fee turned off, passengers in that city pay €0 even if there are rules. On in {{enabled}} of {{total}}.',
          ON: 'On',
          OFF: 'Off',
          ENABLE: 'Turn on',
          DISABLE: 'Turn off',
          ENABLE_TITLE: 'Turn on the fee in {{region}}',
          ENABLE_TEXT: 'Trips created from now on with the WAIIS app will pay the fee from the matrix.',
          DISABLE_TITLE: 'Turn off the fee in {{region}}',
          DISABLE_TEXT: 'Trips created from now on will pay €0. Existing trips don’t change.',
          SIM_TITLE: 'Simulator',
          SIM_SUB: 'What a passenger would pay with the current matrix.',
          FARE: 'Trip price',
          SIMULATE: 'Calculate',
          SIM_INVALID: 'Choose a city and enter a price.',
          PASSENGER_TOTAL: 'Passenger pays',
          REASON: {
            rule: 'Rule applied: {{rule}}.',
            channel_exempt: 'Dispatch centre’s own customer: no fee.',
            region_disabled: 'The fee is turned off in this city.',
            no_rule: 'There’s no rule for this service type: no fee.',
          },
          HISTORY_TITLE: 'Audit log',
          HISTORY_SUB: 'All changes to the matrix and the switches.',
          ACTION: {
            rule_created: 'New rule “{{target}}”: {{to}}',
            rule_updated: 'Rule “{{target}}”: {{from}} → {{to}}',
            rule_deleted: 'Rule deleted “{{target}}” (was {{from}})',
            region_toggled: '{{target}}: fee {{from}} → {{to}}',
          },
        },
        CHALLENGES: {
          ADD: 'New challenge',
          TABS_ARIA: 'Challenge status',
          TAB_ALL: 'All',
          PANEL_TITLE: 'Challenges',
          PANEL_SUB: 'The bonus is paid automatically into the driver’s wallet when they complete the challenge.',
          SEARCH: 'Search by title',
          COL_CHALLENGE: 'Challenge',
          COL_SCOPE: 'For',
          COL_GOALS: 'Goals',
          COL_BONUS: 'Bonus',
          COL_COMPLETED: 'Completed',
          EMPTY: 'No challenges match these filters.',
          LOAD_ERROR: 'Couldn’t load the challenges.',
          LOAD_ONE_ERROR: 'Couldn’t load the challenge.',
          SHOWING: 'Showing {{shown}} of {{total}} challenges',
          PER_PAGE: '{{count}} per page',
          PER_PAGE_ARIA: 'Challenges per page',
          GOAL_TRIPS: '{{value}} trips',
          GOAL_HOURS: '{{value}} h online',
          GOAL_FARE: '{{value}} billed',
          GOAL_RATING: 'rating ≥ {{value}}',
          NEW_TITLE: 'New challenge',
          DETAIL_TITLE: 'Challenge',
          BACK: 'Back to challenges',
          SECTION_WHAT: 'The challenge',
          SECTION_WHO: 'Who and when',
          SECTION_GOALS: 'Goals',
          SECTION_BONUS: 'Bonus',
          TITLE: 'Title',
          DESCRIPTION: 'Description',
          DESCRIPTION_HINT: 'What the driver will see in the app.',
          STARTS: 'Starts',
          ENDS: 'Ends',
          DATES_INVALID: 'Enter the start and end, and make sure the end isn’t before the start.',
          GOALS_HINT: 'Fill in the ones that apply: all of them must be met.',
          MIN_TRIPS: 'Trips',
          MIN_HOURS: 'Hours online',
          MIN_FARE: 'Billing (€)',
          MIN_RATING: 'Minimum rating',
          GOALS_INVALID: 'Set at least one goal (rating, from 1 to 5).',
          BONUS_HINT: 'From €1 to €500. Paid into the wallet (BONUS line).',
          BONUS_INVALID: 'Enter a bonus between €1 and €500.',
          CREATE: 'Create challenge',
          SAVED_TITLE: 'Challenge saved',
          SAVE_ERROR: 'Couldn’t save the challenge.',
          LOCKED: 'This challenge has already started: it can’t be changed.',
          PUBLISH: 'Publish',
          PUBLISH_TITLE: 'Publish “{{title}}”',
          PUBLISH_TEXT: 'Drivers in that city and mode will be notified. It can still be edited until it starts.',
          CANCEL: 'Cancel the challenge',
          CANCEL_TITLE: 'Cancel “{{title}}”',
          CANCEL_TEXT: 'It stops counting for everyone. Bonuses already paid aren’t taken back.',
          DELETE: 'Delete',
          DELETE_TITLE: 'Delete “{{title}}”',
          DELETE_TEXT: 'It’s a draft: nobody has seen it yet.',
          ACTION_ERROR: 'Couldn’t complete the action',
          PARTICIPANTS: 'Participants',
          PARTICIPANTS_SUB: 'Each driver’s progress. Green shows what they’ve already completed.',
          PARTICIPANTS_EMPTY: 'Nobody is taking part yet.',
          PAID: 'Bonuses paid',
          PARTICIPANT_in_progress: 'In progress',
          PARTICIPANT_completed: 'Completed, bonus pending',
          PARTICIPANT_paid: 'Bonus paid',
        },
      },
    },
    SIDEBAR: {
      FLEET_PERFORMANCE: 'Performance',
      FLEET_DRIVERS_COUNT: 'Requests to accept: {{count}}',
      FLEET_DOCUMENTS_COUNT: 'Documents that need attention: {{count}}',
      FLEET_DISPATCH_SECTION: 'Dispatch centre',
      FLEET_STANDS: 'Taxi ranks',
      FLEET_ZONES: 'Zones',
      FLEET_DISPATCH_POLICY: 'Dispatch policy',
      FLEET_DATA_SECTION: 'Data',
      PASSENGER_FEES: 'Passenger fee',
      DRIVER_CHALLENGES: 'Challenges',
    },
    PAGE_HEADER: {
      FLEET_PERFORMANCE: 'How each driver is doing: trips, hours, revenue, acceptance and rating.',
      FLEET_STANDS: 'The dispatch centre’s taxi ranks with their geofence and live queue.',
      FLEET_ZONES: 'The dispatch centre’s named zones, for dispatch and reports.',
      FLEET_DISPATCH_POLICY: 'How services are offered among members, and the queue rules.',
      PASSENGER_FEES: 'How much the passenger pays on top of the price, by city, mode and service type.',
      DRIVER_CHALLENGES: 'Challenges with a € bonus for taxi and VTC drivers.',
    },
  },
};
